import React from 'react';
import InterviewDateConfirm from './InterviewDatesSteps/InterviewDateConfirm';

const InterviewConfirmRouter = ({
  changeStep,
  listArray,
  clientID,
  demo,
  singleDateChoice,
  setHasNoChoicesToMake,
  headerText,
  setHasInterviewDate,
  setHasPermission,
  setError,
  hasPreferenceOrderWithNoInterviewDate,
  dateOfInterview,
  selectedDates,
}) => {
  return (
    <div style={{ display: 'flex', width: '100%', height: '100%' }}>
      <InterviewDateConfirm
        changeStep={changeStep}
        clientID={clientID}
        dateOfInterview={dateOfInterview}
        demo={demo}
        hasPreferenceOrderWithNoInterviewDate={hasPreferenceOrderWithNoInterviewDate}
        headerText={headerText}
        listArray={listArray}
        selectedDates={selectedDates}
        setError={setError}
        setHasInterviewDate={setHasInterviewDate}
        setHasNoChoicesToMake={setHasNoChoicesToMake}
        setHasPermission={setHasPermission}
        singleDateChoice={singleDateChoice}
      />
    </div>
  );
};

export default InterviewConfirmRouter;
